module.exports = __webpack_public_path__ + "static/media/checklist-white-bg.e656dcb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/checklist-white-bg.svg
// module id = 1366
// module chunks = 49